class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    gsap.set(".p-top", { opacity: 0 });

    const tl = gsap.timeline({ delay: 0.2 });
    tl.to(".p-top", { opacity: 1, duration: 0.3, ease: "power1.out" })
    .fromTo(".js-mv-01", {opacity:0, y:20}, {opacity:1, y:0, duration:0.2})
    .fromTo(".js-mv-02", {opacity:0, y:20}, {opacity:1, y:0, duration:0.2},)
    .fromTo(".js-mv-03", {opacity:0, y:20}, {opacity:1, y:0, duration:0.2},)
    .fromTo(".js-mv-copy", {clipPath:"inset(0 100% 0 0)"}, {clipPath:"inset(0 0% 0 0)", duration:0.4}, "+=0.1")
    .fromTo([".js-mv-ttl",".js-mv-txt"], {clipPath:"inset(0 100% 0 0)"}, {clipPath:"inset(0 0% 0 0)", duration:0.4}, "+=0.1")
    .fromTo(".js-mv-icon", {opacity:0, y:20}, {opacity:1, y:0, duration:0.2}, "<")
    .fromTo([".js-mv-news",".js-header"], {opacity:0, y:-20}, {opacity:1, y:0, duration:0.2, stagger:0.1}, "<");
    
    let interviewSwiper;

    function initInterviewSwiper() {
      // ページネーション要素の参照を保持
      const paginationEl = document.querySelector('.interviewSwiper .interviewpagination');
      
      if (!paginationEl) {
        return;
      }
      
      // ページネーションのアクティブ状態を更新する関数
      function updatePagination(swiper) {
        if (!paginationEl) return;
        
        const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
        if (bullets.length === 0) return;
        
        // 実際のスライド数を取得
        const realSlides = swiper.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
        const totalSlides = realSlides.length;
        
        // ループモードではrealIndexを使用、取得できない場合はactiveIndexから計算
        let realIndex = swiper.realIndex;
        
        // realIndexが取得できない場合、アクティブなスライドから直接インデックスを取得
        if (realIndex === undefined || realIndex === null || realIndex < 0) {
          const activeSlide = swiper.slides[swiper.activeIndex];
          if (activeSlide) {
            // 複製でないスライドのインデックスを取得
            realIndex = realSlides.indexOf(activeSlide);
            // 見つからない場合は、data-swiper-slide-index属性から取得を試みる
            if (realIndex === -1) {
              const slideIndex = activeSlide.getAttribute('data-swiper-slide-index');
              if (slideIndex !== null) {
                realIndex = parseInt(slideIndex, 10);
              } else {
                // activeIndexから直接計算（ループモードの場合）
                // 実際のスライド数で割った余りを使用
                realIndex = swiper.activeIndex % totalSlides;
                if (realIndex < 0) {
                  realIndex = realIndex + totalSlides;
                }
              }
            }
          } else {
            realIndex = swiper.activeIndex % totalSlides;
            if (realIndex < 0) {
              realIndex = realIndex + totalSlides;
            }
          }
        }
        
        // 正規化（ループモードの場合）
        if (totalSlides > 0) {
          realIndex = ((realIndex % totalSlides) + totalSlides) % totalSlides;
        }
        
        // スライドが1枚移動するたびに、1個次のドットがアクティブになる（6個のドットを循環）
        // realIndexを6で割った余りでドットインデックスを決定
        const activeIndex = realIndex % bullets.length;
        
        // activeIndexが有効な範囲内かチェック
        if (activeIndex >= 0 && activeIndex < bullets.length) {
          // まずすべてのドットからクラスを削除
          bullets.forEach((bullet) => {
            bullet.classList.remove('swiper-pagination-bullet-active');
          });
          
          // アクティブなドットだけにクラスを追加
          if (bullets[activeIndex]) {
            bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
          }
        }
      }
      
      interviewSwiper = new Swiper(".interviewSwiper", {
        loop: true,
        centeredSlides: true,
        slidesPerView: 2,
        speed: 1500,
        breakpoints: {
          768: {
            centeredSlides: true,
            slidesPerView: 6,
          }
        },
        navigation: {
          nextEl: ".js-interview-next",
          prevEl: ".js-interview-prev",
        },
        pagination: false, // カスタムページネーションを使用するため、デフォルトのページネーションを無効化
        // ページネーションの分割数を制御
        on: {
          init: function(swiper) {
            // 実際のスライド数を取得（ループモードの場合は複製されたスライドを除く）
            const realSlides = swiper.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
            const totalSlides = realSlides.length;
            // 4つごとに1つのドットを表示するため、総数を4で割る
            const paginationCount = Math.ceil(totalSlides / 4);
            
            if (!paginationEl) {
              console.error('ページネーション要素が見つかりません');
              return;
            }
            
            // 既存のページネーションをクリア
            paginationEl.innerHTML = '';
            
            // カスタムページネーションを生成
            for (let i = 0; i < paginationCount; i++) {
              const bullet = document.createElement('span');
              bullet.className = 'swiper-pagination-bullet';
              bullet.addEventListener('click', function() {
                // 4つごとにスライドを移動
                swiper.slideToLoop(i * 4);
              });
              paginationEl.appendChild(bullet);
            }
            
            // 初期状態を更新（ページネーション生成後に実行）
            setTimeout(function() {
              updatePagination(swiper);
            }, 50);
          },
          slideChange: function(swiper) {
            updatePagination(swiper);
          },
          slideChangeTransitionEnd: function(swiper) {
            updatePagination(swiper);
          }
        }
      });
    }

    initInterviewSwiper();

    gsap.registerPlugin(ScrollTrigger);

    const $modal = $(".js-modal");
    const $items = $(".c-modal-item");
    let scrollTriggerInstances = [];
    let swiperInstance = null;
    let scrollTop = 0;
  
    function initScrollTrigger() {
      const $scrollContainer = $(".c-modal-content");
      const $items = $(".c-modal-item");
      const itemCount = $items.length;
    
      const totalHeight = itemCount * window.innerHeight;
      const $fakeScroll = $('<div class="fake-scroll"></div>');
      $fakeScroll.css({
        height: totalHeight + "px",
      });
      $scrollContainer.empty().append($fakeScroll);
    
      $(".c-modal-wrap").append($items);
      gsap.set($items, { autoAlpha: 0 });
      gsap.set($items.eq(0), { autoAlpha: 1 });
    
      let currentIndex = 0;
      $scrollContainer.off("scroll").on("scroll", function () {
        const scrollTop = $scrollContainer.scrollTop();
        const vh = window.innerHeight;
        const index = Math.min(Math.floor((scrollTop + vh * 0.5) / vh), itemCount - 1);
      
        if (index !== currentIndex) {
          currentIndex = index;
          gsap.to($items, { autoAlpha: 0, duration: 0.4 });
          gsap.to($items.eq(index), { autoAlpha: 1, duration: 0.6 });
        }
      });

      $modal.off("wheel.modal").on("wheel.modal", function (e) {
        e.preventDefault();
        const delta = e.originalEvent.deltaY;
        const currentScroll = $scrollContainer.scrollTop();
        const newScroll = currentScroll + delta;
      
        const maxScroll = $scrollContainer[0].scrollHeight - $scrollContainer.outerHeight();
        const clamped = Math.max(0, Math.min(newScroll, maxScroll));
      
        $scrollContainer.scrollTop(clamped);
      });
    }
    
  
    function destroyScrollTrigger() {
      scrollTriggerInstances.forEach((st) => st.kill());
      scrollTriggerInstances = [];
      $(".fake-scroll-area").remove();
      gsap.set($items, { clearProps: "all" });
    }
  
    // --------------------------------
    // SP：Swiper
    // --------------------------------
    function initSwiper() {
      swiperInstance = new Swiper(".c-modal-content", {
        wrapperClass: "c-modal-inner",
        slideClass: "c-modal-item",
        slidesPerView: 1,
        speed: 600,
        loop: false,
        pagination: {
          el: ".modalpagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".js-modal-next",
          prevEl: ".js-modal-prev",
        },
      });
      valuesSwiper = new Swiper('.valuesSwiper', {
        slidesPerView: 1,
        centeredSlides: true,
        // spaceBetween: 16,
        loop: true,
      });
    }
    
  
    function destroySwiper() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  
    // --------------------------------
    // モード切り替え
    // --------------------------------
    function modeChange() {
      const winW = $(window).width();
      if (winW > 767) {
        destroySwiper();
        initScrollTrigger();
      } else {
        destroyScrollTrigger();
        initSwiper();
      }
    }
  
    // --------------------------------
    // ウィンドウリサイズ対応
    // --------------------------------
    $(window).on("resize", function () {
      if ($modal.hasClass("is-open")) {
        modeChange();
      }
    });

    $('.js-pop-area').each(function() {
      const $items = $(this).find('.js-pop-item');
      gsap.set($items, {opacity: 0, y: 20});
      gsap.to($items, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.3,
        ease: "power2.out",
        scrollTrigger: {
          trigger: this,
          start: "top bottom-=40%",
          toggleActions: "play none none none"
        }
      });
    });

    $('.js-popin-area').each(function() {
      const $items = $(this).find('.js-popin-item');
      gsap.set($items, {opacity: 0, y: 20, scale: 0.9});
      gsap.to($items, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.6,
        stagger: 0.15,
        ease: "back.out(1.7)",
        scrollTrigger: {
          trigger: this,
          // markers: true,
          start: "top bottom-=50%",
          toggleActions: "play none none none"
        }
      });
    });

    $('.js-bg-item').each(function() {
      gsap.set(this, {clipPath: 'inset(0 100% 0 0)'});
      gsap.to(this, {
        clipPath: 'inset(0 0% 0 0)',
        duration: 0.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: this,
          start: 'top bottom-=30%',
          toggleActions: 'play none none none'
        }
      });
    });

    const $list = $('.s-mv-news-list ul');
    const $listItems = $list.find('li');
    const itemHeight = $listItems.first().outerHeight();
    const total = $listItems.length;
    let index = 0;
    let timer;
  
    function move() {
      index = (index + 1) % total;
      $list.css({
        transform: `translateY(${-index * itemHeight}px)`,
        transition: 'transform 0.5s ease'
      });
    }
  
    function movePrev() {
      index = (index - 1 + total) % total;
      $list.css({
        transform: `translateY(${-index * itemHeight}px)`,
        transition: 'transform 0.5s ease'
      });
    }
  
    function startAuto() {
      timer = setInterval(move, 3000);
    }
  
    function stopAuto() {
      clearInterval(timer);
    }
  
    startAuto();
  
    $('.s-mv-news-list__nav div:first-child').on('click', function () {
      stopAuto();
      movePrev();
      startAuto();
    });
  
    $('.s-mv-news-list__nav div:last-child').on('click', function () {
      stopAuto();
      move();
      startAuto();
    });

    let valuesSwiper = null;

    function initValuesSwiper() {
      const isSp = window.matchMedia('(max-width: 767px)').matches;

      if (isSp) {
        $('.s-values-list').addClass('swiper');
        $('.s-values-list ul').addClass('swiper-wrapper');
        $('.s-values-list li').addClass('swiper-slide');

        valuesSwiper = new Swiper('.valuesSwiper', {
          slidesPerView: 1,
          centeredSlides: true,
          pagination: {
            el: '.valuespagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.js-values-next',
            prevEl: '.js-values-prev',
          },
        });

      } else {
        if (valuesSwiper) {
          valuesSwiper.destroy(true, true);
          valuesSwiper = null;
        }

        $('.s-values-list').removeClass('swiper');
        $('.s-values-list ul').removeClass('swiper-wrapper');
        $('.s-values-list li').removeClass('swiper-slide');
      }
    }

    initValuesSwiper();

    $(window).on('resize', function () {
      initValuesSwiper();
    });
  }
}